<template>
  <div class="h-full w-full" v-if="objectCard">
    <!-- -->
    <div class="w-full h-full">
      <!-- Title -->
      <div
        class="flex pt-4 pb-4 pl-4 mb-5 justify-between items-center sticky top-0 z-20 border-rou bg-white"
      >
        <div class="name-user">
          <div class="flex items-center">
            <div class="text-xl font-semibold">
              {{ objectCard?.fullname }}, {{ objectCard?.metadata?.age }}
            </div>
            <img
              v-if="objectCard?.explore?.verified === 2"
              class="pl-2 pr-2"
              src="../../../assets/icon_svg/material-symbols_default.svg"
            />
            <img
              v-else
              @click="onShowPopupVerify()"
              class="pl-2 pr-2"
              src="../../../assets/icon_svg/material-symbols_verified.svg"
            />
          </div>
          <div class="text-left flex items-center" v-if="objectCard.onlineNow">
            <img
              src="../../../assets/icon_svg/ic_online.svg"
              class="mr-2"
              alt=""
            />
            <div class="text-base">Active today</div>
          </div>
        </div>
        <div>
          <div
            class="rounded-lg bg-blue-500 p-2 flex gap-2 cursor-pointer"
            @click="onChatWidthFriend(objectCard)"
          >
            <img src="../../../assets/icon_svg/ic_mes.svg" alt="" />
            <span class="text-white text-sm">Texting </span>
          </div>
        </div>
      </div>
      <!-- Image 01 -->

      <div class="h-full hide-scroll">
        <div
          class="flex justify-center items-center"
          v-if="
            objectCard?.profiles?.avatars.length !== 0 &&
            objectCard?.profiles?.avatars[0]
          "
        >
          <div class="w-full relative flex justify-center items-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[0].meta.url})`,
              }"
            ></div>
          </div>
        </div>

        <!-- Prompt 01 -->

        <div
          class="flex w-full h-[99px] items-center relative mt-5"
          v-if="
            objectCard?.profiles?.prompts &&
            objectCard?.profiles?.prompts[0] &&
            objectCard?.profiles?.prompts[0].id.length !== 0
          "
        >
          <div class="h-full flex items-end mr-1">
            <div
              class="ic_avatar"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[0].meta.url})`,
              }"
            ></div>
          </div>
          <div class="prompt-item">
            <div class="text-left">
              <div class="text-lg font-semibold">
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[0]).codeTitle
                }}
              </div>
              <div>
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[0]).answerValue
                }}
              </div>
            </div>
          </div>
          <img
            @click="onClickLike(objectCard)"
            class="absolute top-14 right-2 cursor-pointer img-icon-like"
            src="../../../assets/icon_svg/icon_like.svg"
            alt=""
            width="70"
          />
        </div>

        <!-- infor -->
        <div class="flex justify-center w-full items-center relative mt-5">
          <div class="w-[98%] border-rou pl-4 pr-4 pt-4 pb-4">
            <div class="w-full flex flex-wrap overflow-hidden relative">
              <div
                ref="scrollContainer"
                class="w-full flex items-center justify-start pt-2 pb-2 border-b-2"
              >
                <div
                  v-if="objectCard?.profiles?.gender"
                  class="flex items-center justify-center pl-4 pr-4 border-r-2 gap-2"
                >
                  <img src="../../../assets/ic_tinder/ic_gender.svg" alt="" />
                  <span>{{ bingGender(objectCard?.profiles?.gender) }}</span>
                </div>
                <Carousel :breakpoints="breakpoints">
                  <Slide index="1" v-if="objectCard?.profiles?.height">
                    <div
                      class="flex w-full items-center justify-center p-2 border-r-2 gap-2"
                    >
                      <img
                        src="../../../assets/ic_tinder/ic_height.svg"
                        alt=""
                      />
                      <span>{{ objectCard?.profiles?.height }} cm</span>
                    </div>
                  </Slide>
                  <Slide index="2" v-if="objectCard?.profiles?.address">
                    <div
                      class="flex w-full items-center justify-center p-2 border-r-2 gap-2"
                    >
                      <img
                        src="../../../assets/ic_tinder/ic_location.svg"
                        alt=""
                      />
                      <span
                        :title="objectCard?.profiles?.address"
                        class="w-[100px] text-ellipsis overflow-hidden whitespace-nowrap"
                        >{{ objectCard?.profiles?.address }}</span
                      >
                    </div>
                  </Slide>
                  <Slide index="3" v-if="objectCard?.profiles?.drug">
                    <div
                      class="flex w-full items-center justify-center p-2 border-r-2 gap-2"
                    >
                      <img src="../../../assets/ic_tinder/ic_drug.svg" alt="" />
                      <span>{{ bingDrug(objectCard?.profiles?.drug) }}</span>
                    </div>
                  </Slide>
                  <Slide index="4" v-if="objectCard?.profiles?.childrenPlan">
                    <div
                      class="flex w-full items-center justify-center p-2 border-r-2 gap-2"
                    >
                      <img
                        src="../../../assets/ic_tinder/ic_children.svg"
                        alt=""
                      />
                      <span
                        :title="objectCard?.profiles?.childrenPlan"
                        class="w-[150px] text-ellipsis overflow-hidden whitespace-nowrap"
                        >{{
                          bingChildrens(objectCard?.profiles?.childrenPlan)
                        }}</span
                      >
                    </div>
                  </Slide>
                  <Slide index="5" v-if="objectCard?.profiles?.drinking">
                    <div
                      class="flex w-full items-center justify-center p-2 border-r-2 gap-2"
                    >
                      <img
                        src="../../../assets/ic_tinder/ic_drink.svg"
                        alt=""
                      />
                      <span
                        class="w-[100px] text-ellipsis overflow-hidden whitespace-nowrap"
                        >{{
                          bingDrinking(objectCard?.profiles?.drinking)
                        }}</span
                      >
                    </div>
                  </Slide>
                </Carousel>
              </div>
            </div>
            <div
              v-if="objectCard?.profiles?.orientationSexuals"
              class="w-full flex items-center justify-start pt-2 pb-2 border-b-2 gap-3 pl-2 pr-2"
            >
              <img src="../../../assets/ic_tinder/ic_sexual.svg" alt="" />
              <div>
                <span
                  v-for="(item, index) in bingSexuals(
                    objectCard?.profiles?.orientationSexuals
                  )"
                  :key="index"
                >
                  {{ item
                  }}<span
                    v-if="
                      index <
                      bingSexuals(objectCard?.profiles?.orientationSexuals)
                        .length -
                        1
                    "
                    >,&nbsp;</span
                  >
                </span>
              </div>
            </div>
            <div
              v-if="objectCard?.profiles?.jobTitle"
              class="w-full flex items-center justify-start pt-2 pb-2 border-b-2 gap-3 pl-2 pr-2"
            >
              <img src="../../../assets/ic_tinder/ic_company.svg" alt="" />
              <span
                >{{ objectCard?.profiles?.jobTitle }} tại
                {{ objectCard?.profiles?.company }}</span
              >
            </div>
            <div
              v-if="objectCard?.profiles?.school"
              class="w-full flex items-center justify-start pt-2 pb-2 border-b-2 gap-3 pl-2 pr-2"
            >
              <img src="../../../assets/ic_tinder/ic_education.svg" alt="" />
              <span>{{ objectCard?.profiles?.school }}</span>
            </div>
            <div
              v-if="objectCard?.profiles?.languages.length !== 0"
              class="w-full flex items-center justify-start pt-2 pb-2 border-b-2 gap-3 pl-2 pr-2"
            >
              <img src="../../../assets/ic_tinder/ic_language.svg" alt="" />
              <div>
                <span
                  v-for="(item, index) in bingLanguageKnow(
                    objectCard?.profiles?.languages
                  )"
                  :key="index"
                >
                  {{ item
                  }}<span
                    v-if="
                      index <
                      bingLanguageKnow(objectCard?.profiles?.languages).length -
                        1
                    "
                    >,&nbsp;</span
                  >
                </span>
              </div>
            </div>
            <div
              v-if="objectCard?.profiles?.ethnicitys.length !== 0"
              class="w-full flex items-center justify-start pt-2 pb-2 gap-3 pl-2 pr-2"
            >
              <img src="../../../assets/ic_tinder/ic_ethnicity.svg" alt="" />
              <div>
                <span
                  v-for="(item, index) in bingEthnicities(
                    objectCard?.profiles?.ethnicitys
                  )"
                  :key="index"
                >
                  {{ item
                  }}<span
                    v-if="
                      index <
                      bingEthnicities(objectCard?.profiles?.ethnicitys).length -
                        1
                    "
                    >,&nbsp;</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Love -->
        <div
          class="flex justify-center w-full items-center relative mt-5"
          v-if="
            objectCard?.profiles?.about || objectCard?.profiles?.datingPurpose
          "
        >
          <div class="w-[98%] border-rou pl-4 pr-4 pt-4 pb-4">
            <div class="w-full text-left">
              {{ objectCard?.profiles?.about }}
            </div>
            <div
              class="w-full flex items-center"
              v-if="objectCard?.profiles?.datingPurpose"
            >
              <img
                :src="
                  bingDatingPurposes(objectCard?.profiles?.datingPurpose)
                    .urlPurposes
                "
                alt=""
                width="30"
              />
              <div class="w-full text-left ml-4">
                <div>Looking for</div>
                <div class="font-semibold">
                  {{
                    bingDatingPurposes(objectCard?.profiles?.datingPurpose)
                      .valuePurposes
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Imag 02 -->
        <div
          class="flex justify-center items-center mt-5"
          v-if="
            objectCard?.profiles?.avatars.length !== 0 &&
            objectCard?.profiles?.avatars[1]
          "
        >
          <div class="w-full relative flex justify-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[1].meta.url})`,
              }"
            ></div>
          </div>
        </div>

        <!-- Image 03 -->
        <div
          class="flex justify-center items-center mt-5"
          v-if="
            objectCard?.profiles?.avatars.length !== 0 &&
            objectCard?.profiles?.avatars[2]
          "
        >
          <div class="w-full relative flex justify-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[2].meta.url})`,
              }"
            ></div>
          </div>
        </div>

        <!-- Prompt 02 -->
        <div
          class="flex w-full h-[99px] items-center relative mt-5"
          v-if="
            objectCard?.profiles?.prompts &&
            objectCard?.profiles?.prompts[1] &&
            objectCard?.profiles?.prompts[1].id.length !== 0
          "
        >
          <div class="h-full flex items-end mr-1">
            <div
              class="ic_avatar"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[0].meta.url})`,
              }"
            ></div>
          </div>
          <div class="prompt-item">
            <div class="text-left">
              <div class="text-lg font-semibold">
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[1]).codeTitle
                }}
              </div>
              <div>
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[1]).answerValue
                }}
              </div>
            </div>
          </div>
          <img
            @click="onClickLike(objectCard)"
            class="absolute top-14 right-2 cursor-pointer img-icon-like"
            src="../../../assets/icon_svg/icon_like.svg"
            alt=""
            width="70"
          />
        </div>

        <!-- Basic information -->

        <div
          class="flex justify-center w-full items-center relative mt-5"
          v-if="
            objectCard?.profiles?.zodiac ||
            objectCard?.profiles?.familyFlan ||
            objectCard?.profiles?.education ||
            objectCard?.profiles?.covidVaccine ||
            objectCard?.profiles?.personality ||
            objectCard?.profiles?.communicationType ||
            objectCard?.profiles?.loveStyle
          "
        >
          <div class="w-[98%] border-rou pl-4 pr-4 pt-4 pb-4">
            <div class="w-full bg-border-bottom padding-text-user text-left">
              <div class="text-base font-semibold">Basic information</div>

              <div class="w-full bh-margin-description mt-2 p-2">
                <button
                  class="item-option pl-2 pr-2 pt-1 pb-1 rounded-xl border-solid border-2 border-s-pink-100 mr-3 mb-3"
                  v-for="(item, index) in bingBasicInformation(
                    objectCard?.profiles
                  )"
                  :key="index"
                >
                  <div class="flex items-center">
                    <img
                      width="25"
                      class="pr-1 img_ic"
                      :src="item.icDefault"
                      alt=""
                    />
                    <span>{{ item.value }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Life style -->
        <div
          class="flex justify-center w-full items-center relative mt-5"
          v-if="
            objectCard?.profiles?.pet ||
            objectCard?.profiles?.drinking ||
            objectCard?.profiles?.smoking ||
            objectCard?.profiles?.workout ||
            objectCard?.profiles?.dietaryPreference ||
            objectCard?.profiles?.socialMedia ||
            objectCard?.profiles?.sleepingHabit
          "
        >
          <div class="w-[98%] border-rou pl-4 pr-4 pt-4 pb-4">
            <div
              class="w-full bg-border-bottom padding-text-user text-left"
              v-if="bingLifeStyleStatic(objectCard?.profiles).length !== 0"
            >
              <div class="text-base font-semibold">Life style</div>

              <div class="w-full bh-margin-description mt-2 p-2">
                <button
                  class="item-option pl-2 pr-2 pt-1 pb-1 rounded-xl border-solid border-2 border-s-pink-100 mr-3 mb-3"
                  v-for="(item, index) in bingLifeStyleStatic(
                    objectCard?.profiles
                  )"
                  :key="index"
                >
                  <div class="flex items-center">
                    <img
                      width="25"
                      class="pr-1 img_ic"
                      :src="item.icDefault"
                      alt=""
                    />
                    <span>{{ item.value }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Image 04 -->
        <div
          class="flex justify-center items-center mt-5"
          v-if="objectCard?.profiles?.avatars[3]"
        >
          <div class="w-full relative flex justify-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[3].meta.url})`,
              }"
            ></div>
          </div>
        </div>

        <!-- Prompt 03 -->
        <div
          class="flex w-full h-[99px] items-center relative mt-5"
          v-if="
            objectCard?.profiles?.prompts &&
            objectCard?.profiles?.prompts[2] &&
            objectCard?.profiles?.prompts[2].id.length !== 0
          "
        >
          <div class="h-full flex items-end mr-1">
            <div
              class="ic_avatar"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[0].meta.url})`,
              }"
            ></div>
          </div>
          <div class="prompt-item">
            <div class="text-left">
              <div class="text-lg font-semibold">
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[2]).codeTitle
                }}
              </div>
              <div>
                {{
                  bingPromptAnswer(objectCard?.profiles?.prompts[2]).answerValue
                }}
              </div>
            </div>
          </div>
          <img
            @click="onClickLike(objectCard)"
            class="absolute top-14 right-2 cursor-pointer img-icon-like"
            src="../../../assets/icon_svg/icon_like.svg"
            alt=""
            width="70"
          />
        </div>

        <!-- Image4 -->
        <div
          class="flex justify-center items-center mt-5"
          v-if="
            objectCard?.profiles?.avatars.length !== 0 &&
            objectCard?.profiles?.avatars[4]
          "
        >
          <div class="w-full relative flex justify-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[4].meta.url})`,
              }"
            ></div>
          </div>
        </div>

        <!-- Image 5 -->
        <div
          class="flex justify-center items-center mt-5"
          v-if="
            objectCard?.profiles?.avatars.length !== 0 &&
            objectCard?.profiles?.avatars[5]
          "
        >
          <div class="w-full relative flex justify-center">
            <div
              class="ic_image"
              :style="{
                'background-image': `url(${objectCard?.profiles?.avatars[5].meta.url})`,
              }"
            ></div>
          </div>
        </div>
        <!-- Interests -->
        <div
          class="flex justify-center w-full items-center relative mt-5"
          v-if="objectCard?.profiles?.interests.length !== 0"
        >
          <div class="w-[98%] border-rou pl-4 pr-4 pt-4 pb-4">
            <div class="w-full text-left">
              <div class="font-semibold">My interests</div>
              <div class="text-base">
                <span
                  v-for="(item, index) in bingInterests(
                    objectCard?.profiles?.interests
                  )"
                  :key="index"
                >
                  {{ item
                  }}<span
                    v-if="
                      index <
                      bingInterests(objectCard?.profiles?.interests).length - 1
                    "
                    >,&nbsp;</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="h-40"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "detail-user",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      image01: require("@/assets/ic_canhan/thuuyen01.jpg"),
      image02: require("@/assets/ic_canhan/thuuyen02.jpg"),
      image03: require("@/assets/ic_canhan/thuuyen03.jpg"),
      image04: require("@/assets/ic_canhan/thuuyen04.jpg"),
      image05: require("@/assets/ic_canhan/thuuyen05.jpg"),
      image06: require("@/assets/ic_canhan/thuuyen06.jpg"),

      icZodiac: require("@/assets/ic_tinder/astrological_sign@2x.png"),
      icFamilyFlan: require("@/assets/ic_tinder/family@1x.png"),
      icEducation: require("@/assets/ic_tinder/education@1x.png"),
      icCovidVaccine: require("@/assets/ic_tinder/covid_comfort@1x.png"),
      icPersonality: require("@/assets/ic_tinder/kietinhcach@2x.png"),
      icCommunicationType: require("@/assets/ic_tinder/communication_style@2x.png"),
      icLoveStyle: require("@/assets/ic_tinder/love_language@1x.png"),

      icPet: require("@/assets/ic_tinder/pets@1x.png"),
      icDrinking: require("@/assets/ic_tinder/drink_of_choice@1x.png"),
      icSmoking: require("@/assets/ic_tinder/smoking@1x.png"),
      icWorkout: require("@/assets/ic_tinder/social_media@1x.png"),
      icDietaryPreference: require("@/assets/ic_tinder/appetite@1x.png"),
      icSocialMedia: require("@/assets/ic_tinder/social_media@1x.png"),
      icSleepingHabit: require("@/assets/ic_tinder/sleeping_habits@1x.png"),

      propertyDetail: {
        zodiac: "aquarius",
        education: "item_1",
        familyPlan: "item_1",
        covidVaccine: "preferNotToSay",
        personality: "enfj",
        communicationType: "item_1",
        loveStyle: "item_1",
        pet: "item_1",
        drinking: "item_1",
        smoking: "item_1",
        workout: "everyday",
        dietaryPreference: "carnivore",
        socialMedia: "item_1",
        sleepingHabit: "item_1",
      },

      listPurposes: [
        {
          code: "item_1",
          url: require("@/assets/ic_dialog/relationship_intent_cupid@1x.png"),
        },
        {
          code: "item_2",
          url: require("@/assets/ic_dialog/relationship_intent_heart_eyes@2x.png"),
        },
        {
          code: "item_3",
          url: require("@/assets/ic_dialog/relationship_intent_clinking_glasses@1x.png"),
        },
        {
          code: "item_4",
          url: require("@/assets/ic_dialog/relationship_intent_tada@2x.png"),
        },
        {
          code: "item_5",
          url: require("@/assets/ic_dialog/relationship_intent_wave@3x.png"),
        },
        {
          code: "item_6",
          url: require("@/assets/ic_dialog/relationship_intent_thinking_face@2x.png"),
        },
      ],

      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },

  setup() {
    const scrollContainer = ref(null);

    const scrollRight = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollBy({
          top: 0,
          left: 500,
          behavior: "smooth",
        });
      }
    };

    return {
      scrollContainer,
      scrollRight,
    };
  },

  props: {
    renderObjectCard: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    objectCard() {
      return this.renderObjectCard;
    },

    renderStaticCommon() {
      return this.$store.state.commonModule.listLifeStyleCommons;
    },

    renderBasicInformation() {
      return this.$store.state.commonModule.listInformationBasic;
    },

    renderLifeStyle() {
      return this.$store.state.commonModule.listLifeStyleStatic;
    },

    renderPrompt() {
      return this.$store.state.commonModule.listPromptRegister;
    },
    renderStaticRegister() {
      return this.$store.state.commonModule.listStaticRegister;
    },
  },

  mounted() {},

  methods: {
    ...mapActions(["getListMessageChanel"]),
    ...mapMutations(["setListMessageSelected"]),
    async onChatWidthFriend(val) {
      debugger;
      await this.getListMessageChanel({
        chanelId: val.channelId,
        pageSize: 50,
        currentPage: 0,
      }).then((data) => {
        // Xét giá trị cho Mutation: để show popup nhắn tin
        this.setListMessageSelected({
          idChannel: val.channelId,
          dataClient: data.clients,
          isShowForm: true,
          dataMessages: data.list_data,
        });

        this.$emit("onShowFormChat", true);
      });
      this.$emit("onChangeChatWidthFriend", val);
    },
    bingPromptAnswer(val) {
      let prompts = this.renderPrompt;
      for (const category of prompts) {
        const item = category.prompts.find(
          (prompt) => prompt.code === val.codePrompt
        );
        if (item) {
          return {
            codeTitle: item.value,
            answerValue: val.answer,
          };
        }
      }
    },

    bingLanguageKnow(val) {
      let languages = this.renderStaticCommon.languages;
      let result = [];
      debugger;
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        const findData = languages.find((x) => x.code === element);
        if (findData) {
          result.push(findData.value);
        }
      }
      return result;
    },

    bingInterests(val) {
      let interests = this.renderStaticCommon.interests;
      let result = [];

      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        const findData = interests.find((x) => x.code === element);
        if (findData) {
          result.push(findData.value);
        }
      }
      return result;
    },

    bingSexuals(val) {
      let sexuals = this.renderStaticCommon.sexuals;
      let result = [];
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        const findData = sexuals.find((x) => x.code === element);
        if (findData) {
          result.push(findData.value);
        }
      }
      return result;
    },

    bingEthnicities(val) {
      let ethnicities = this.renderStaticRegister.ethnicities;
      let result = [];
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        const findData = ethnicities.find((x) => x.code === element);
        if (findData) {
          result.push(findData.value);
        }
      }
      return result;
    },

    bingGender(val) {
      let genders = this.renderStaticCommon.genders;

      const findData = genders.find((x) => x.code === val);
      if (findData) {
        return findData.value;
      }
    },

    bingDatingPurposes(val) {
      let datingPurposes = this.renderStaticCommon.datingPurposes;

      const findData = datingPurposes.find((x) => x.code === val);
      const findUrl = this.listPurposes.find((x) => x.code === val);
      if (findData) {
        return {
          valuePurposes: findData.value,
          urlPurposes: findUrl.url,
        };
      }
    },

    bingDrug(val) {
      let drugs = this.renderStaticRegister.drugs;

      const findData = drugs.find((x) => x.code === val);
      if (findData) {
        return findData.value;
      }
    },
    bingDrinking(val) {
      let drinkings = this.renderStaticRegister.drinkings;

      const findData = drinkings.find((x) => x.code === val);
      if (findData) {
        return findData.value;
      }
    },
    bingChildrens(val) {
      let childrens = this.renderStaticRegister.childrens;

      const findData = childrens.find((x) => x.code === val);
      if (findData) {
        return findData.value;
      }
    },
    bingSmokings(val) {
      let smokings = this.renderStaticRegister.smokings;

      const findData = smokings.find((x) => x.code === val);
      if (findData) {
        return findData.value;
      }
    },
    bingBasicInformation(val) {
      debugger;
      const zodiacValue = val.zodiac;
      const familyFlanValue = val.familyFlan;
      const educationValue = val.education;
      const covidVaccineValue = val.covidVaccine;
      const personalityValue = val.personality;
      const communicationTypeValue = val.communicationType;
      const loveStyleValue = val.loveStyle;
      // eslint-disable-next-line prettier/prettier
      const informationBasic = this.renderBasicInformation;
      let resultData = [];
      if (zodiacValue) {
        const findData = informationBasic.zodiacs.find(
          (x) => x.code === zodiacValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icZodiac,
            value: findData.value,
          });
        }
      }
      if (familyFlanValue) {
        const findData = informationBasic.familyPlans.find(
          (x) => x.code === familyFlanValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icFamilyFlan,
            value: findData.value,
          });
        }
      }
      if (educationValue) {
        const findData = informationBasic.educations.find(
          (x) => x.code === educationValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icEducation,
            value: findData.value,
          });
        }
      }
      if (covidVaccineValue) {
        const findData = informationBasic.covidVaccines.find(
          (x) => x.code === covidVaccineValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icCovidVaccine,
            value: findData.value,
          });
        }
      }
      if (personalityValue) {
        const findData = informationBasic.personalities.find(
          (x) => x.code === personalityValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icPersonality,
            value: findData.value,
          });
        }
      }
      if (communicationTypeValue) {
        const findData = informationBasic.communicationStyles.find(
          (x) => x.code === communicationTypeValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icCommunicationType,
            value: findData.value,
          });
        }
      }
      if (loveStyleValue) {
        const findData = informationBasic.loveStyles.find(
          (x) => x.code === loveStyleValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icLoveStyle,
            value: findData.value,
          });
        }
      }
      return resultData;
    },

    bingLifeStyleStatic(val) {
      const petValue = val.pet;
      const drinkingValue = val.drinking;
      const smokingValue = val.smoking;
      const workoutValue = val.workout;
      const dietaryPreferenceValue = val.dietaryPreference;
      const socialMediaValue = val.socialMedia;
      const sleepingHabitValue = val.sleepingHabit;
      // eslint-disable-next-line prettier/prettier
      const lifeStyleStatic = this.renderLifeStyle;
      let resultData = [];
      if (petValue) {
        const findData = lifeStyleStatic.pets.find((x) => x.code === petValue);
        if (findData) {
          resultData.push({
            icDefault: this.icPet,
            value: findData.value,
          });
        }
      }
      if (drinkingValue) {
        const findData = lifeStyleStatic.drinkings.find(
          (x) => x.code === drinkingValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icDrinking,
            value: findData.value,
          });
        }
      }
      if (smokingValue) {
        const findData = lifeStyleStatic.smokings.find(
          (x) => x.code === smokingValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icSmoking,
            value: findData.value,
          });
        }
      }
      if (workoutValue) {
        const findData = lifeStyleStatic.workouts.find(
          (x) => x.code === workoutValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icWorkout,
            value: findData.value,
          });
        }
      }
      if (dietaryPreferenceValue) {
        const findData = lifeStyleStatic.foodPreferences.find(
          (x) => x.code === dietaryPreferenceValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icDietaryPreference,
            value: findData.value,
          });
        }
      }
      if (socialMediaValue) {
        const findData = lifeStyleStatic.socials.find(
          (x) => x.code === socialMediaValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icSocialMedia,
            value: findData.value,
          });
        }
      }
      if (sleepingHabitValue) {
        const findData = lifeStyleStatic.sleepingStyles.find(
          (x) => x.code === sleepingHabitValue
        );
        if (findData) {
          resultData.push({
            icDefault: this.icSleepingHabit,
            value: findData.value,
          });
        }
      }
      return resultData;
    },

    onClickLike(val) {
      this.$emit("onChangeLikeCard", val);
    },

    onClickBack(val) {
      this.$emit("onBackCardChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.ic_image {
  width: 98%;
  height: 590px;
  background-size: cover; /* Hiển thị ảnh với tỷ lệ ảnh gốc và điều chỉnh kích thước để không cắt bớt */
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 30px;
  -webkit-background-size: cover;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.bor-r {
  border-radius: 30px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.ic_avatar {
  width: 35px;
  height: 35px;
  background-size: cover; /* Hiển thị ảnh với tỷ lệ ảnh gốc và điều chỉnh kích thước để không cắt bớt */
  background-position: center; /* Canh giữa ảnh */
  background-repeat: no-repeat; /* Không lặp lại ảnh */
  border: 1px solid;
  border-radius: 50px;
}

.prompt-item {
  width: calc(100% - 40px);
  padding: 10px;
  height: 100px;
  border: 1px solid;
  background-color: #4a88d9;
  color: white;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.img-icon-like {
  transition: 0.3s;
}
.img-icon-like:hover {
  transform: scale(1.1);
}

.overflow-x-auto {
  scrollbar-width: thin;
  scrollbar-color: #4a5568 #edf2f7;
}

.overflow-x-auto::-webkit-scrollbar {
  height: 8px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #edf2f7;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background-color: #4a5568;
  border-radius: 10px;
  border: 3px solid #edf2f7;
}

.border-rou {
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
</style>
